    // Copyright (c) 2020 Deere & Company

const spaClaimsFilterOptions = [
    ['claimNumber'],
    ['reference1'],
    ['pin'],
    ['recordInfo', 'createdBy', 'lastName'],
    ['recordInfo', 'createdBy', 'firstName'],
    ['recordInfo', 'createdBy', 'id'],
    ['responsibleAccount', 'name'],
    ['responsibleAccount', 'location', 'city'],
    ['responsibleAccount', 'location', 'state'],
    ['responsibleAccount', 'account'],
    ['specialAllowanceType', 'value'],
    ['status', 'value']
];

export default spaClaimsFilterOptions;



// WEBPACK FOOTER //
// ./src/tabm/wip/services/spa-claims-filter-options.js